var map = {
	"./adventure.svg": "2dcc",
	"./all.svg": "d9e7",
	"./biography.svg": "616a",
	"./comedy.svg": "2ab8",
	"./default.svg": "a34c",
	"./drama.svg": "e9ae",
	"./fantasy.svg": "c389",
	"./horror.svg": "9ded",
	"./how-to.svg": "d25d",
	"./mystery.svg": "438e",
	"./romance.svg": "a142",
	"./science-fiction.svg": "52e5",
	"./self-help.svg": "aade",
	"./thriller.svg": "c5dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a921";